import { Button } from "design-system/atoms/Button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useDeleteBigBlueIntegrationMutation } from "modules/settings/hooks/bigblue/useDeleteBigBlueIntegrationMutation"
import { useTranslation } from "react-i18next"

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleted: () => void
}

export const DeleteBigBlueIntegration = ({ open, onOpenChange, onDeleted }: Props) => {
  const { t } = useTranslation()
  const { mutateAsync, isPending } = useDeleteBigBlueIntegrationMutation()

  const onDelete = async () => {
    await mutateAsync()
    onOpenChange(false)
    onDeleted()
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("settings.integrations.bigblue.integrationCard.deleteIntegration.title")}
          </DialogTitle>
          <DialogDescription>
            {t("settings.integrations.bigblue.integrationCard.deleteIntegration.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="secondary" onClick={() => onOpenChange(false)} disabled={isPending}>
            {t("settings.integrations.bigblue.integrationCard.deleteIntegration.actions.cancel")}
          </Button>
          <Button variant="destructive" onClick={onDelete} disabled={isPending}>
            {t("settings.integrations.bigblue.integrationCard.deleteIntegration.actions.delete")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
